let state = {
  
    disciplinas:[
        
    ],

}

export default state